import React, { useState } from "react";
import Modal from "components/Modal";
import { Row, Col } from "reactstrap";
import {
	Container,
	Button,
	Grid,
	Card,
	CardContent,
	CardActions,
	CardHeader,
	Typography,
	Input,
	Output,
	Select,
	makeStyles,
} from "@material-ui/core";
import { Image } from "components/Image";
import data from "../data/software.json";
import { TramOutlined } from "@material-ui/icons";
const useStyles = makeStyles((theme) => ({
	image: {
		borderRadius: theme.shape.borderRadius,
	},
}));
function ApplicationDetails(props) {
	const { title, image, description, links, index = 1 } = props;
	const classes = useStyles();
	return (
		<Card style={{ marginBottom: 12 }}>
			<Row>
			<Col>
				<CardHeader title={title} style={{textAlign: "left", marginLeft: 10}}></CardHeader>
			</Col>
			<Col style={{marginLeft:20, marginTop: 0, marginBottom: 5}}>
				{links && (
					<CardActions
						style={{
							display: "flex",
							justifyContent: "flex-end",
							padding: `0.5rem`,
						}}
					>
						{links.map((l) => (
							<a href={l.href}>
								<Button style={{ margin: 4, }}>{l.text}</Button>
							</a>
						))}
					</CardActions>
				)}

			</Col>
			</Row>
			<Row>
				<Col xs={12} sm={{ size: 4, order: index % 2 ? 2 : 1 }}>
					<Image src={image} alt={title} className={classes.image} />
				</Col>
				<Col xs={12} sm={{ size: 8, order: index % 2 ? 1 : 2 }}>
					<CardContent>
						<Typography>{description}</Typography>
					</CardContent>
				</Col>
			</Row>
		</Card>
	);
}


// calculates the ventilation rate contains formula for final value and translates the times into military time for calculations
// also controls the meter and feet unit conversions
function Ventilation_Rate()
{
	var TinH = document.getElementById("TinH");
	var TinM = document.getElementById("TinM");
	var ToutH = document.getElementById("ToutH");
	var ToutM = document.getElementById("ToutM");
	var NumP = document.getElementById("NumP");
	var CO2in = document.getElementById("CO2in");
	var CO2out = document.getElementById("CO2out");
	var Length = document.getElementById("Length");
	var RWidth = document.getElementById("RWidth");
	var Stories = document.getElementById("Stories");
	var Answer = document.getElementById("Answer");

	var Length_unit = document.getElementById("Length_unit");
	var Width_unit = document.getElementById("Width_unit");

	var Length_new;
	var Width_new;

	var Timein_unit = document.getElementById("Timein_unit");
	var Timeout_unit = document.getElementById("Timeout_unit");

	var TinH_new;
	var ToutH_new;

 	if (Timein_unit.value === "AM" && TinH.value == 12)
		{
			TinH_new = 0;
		}

	if (Timein_unit.value === "AM" && TinH.value > 0 && TinH.value <12)
		{
			TinH_new = Number(TinH.value);
		}

	if (Timein_unit.value === "PM" && TinH.value == 12)
		{
			TinH_new = Number(TinH.value);
		}

	if (Timein_unit.value === "PM" && TinH.value > 0 && TinH.value <12)
		{
			TinH_new = Number(TinH.value) + 12
		}

	if (Timeout_unit.value === "AM" && ToutH.value == 12)
		{
			ToutH_new = 0;
		}

	if (Timeout_unit.value === "AM" && ToutH.value > 0 && ToutH.value <12)
		{
			ToutH_new = Number(ToutH.value);
		}

	if (Timeout_unit.value === "PM" && ToutH.value == 12)
		{
			ToutH_new = Number(ToutH.value);
		}

	if (Timeout_unit.value === "PM" && ToutH.value > 0 && ToutH.value <12)
		{
			ToutH_new = Number(ToutH.value) + 12;
		}

	if (Length_unit.value === "Meter")
		{
			Length_new = Number(Length.value)
		}

	if (Length_unit.value === "Feet")
		{
			Length_new = Number(Length.value)/3.280839895
		}

	if (Width_unit.value === "Meter")
		{
			Width_new = Number(RWidth.value)
		}

	if (Width_unit.value === "Feet")
		{
			Width_new = Number(RWidth.value)/3.280839895
		}

// numerical value of height and the volume equation
	var Height_val = Number(Stories.value)*2.4384
	var Veff = Height_val*Width_new*Length_new

	var Ti = TinH_new*60 + Number(TinM.value);
	var Tf = ToutH_new*60 + Number(ToutM.value);

	// log value of CO2 in over CO2 out
	var LogCDO = Math.log(Number(CO2in.value)/Number(CO2out.value));

	// MBar is Mbar/c where c is concentration and Q is the time averaged flowrate
	var Mbar = Number(NumP.value)*609.1*.5*((1/Number(CO2in.value))-(1/Number(CO2out.value)));
	var Q = Mbar + Veff/(Tf-Ti)*LogCDO;

	// Vent rate defined as Q/Volume
	var Vent_rate;
	Vent_rate = 60*Q/Veff

	return(
		Answer.value = Math.round(Vent_rate)
	)
}

// function for clearing the inputs of any value
function clear()
{
	var TinH = document.getElementById("TinH");
	var TinM = document.getElementById("TinM");
	var ToutH = document.getElementById("ToutH");
	var ToutM = document.getElementById("ToutM");
	var NumP = document.getElementById("NumP");
	var CO2in = document.getElementById("CO2in");
	var CO2out = document.getElementById("CO2out");
	var Length = document.getElementById("Length");
	var RWidth = document.getElementById("RWidth");
	var Stories = document.getElementById("Stories");
	var Answer = document.getElementById("Answer");
	var Month = document.getElementById("Month");
	var Day = document.getElementById("Day");
	var Year = document.getElementById("Year");


	return(TinH.value = "", TinM.value = "", ToutH.value = "", ToutM.value = "", NumP.value = "", CO2in.value = "", CO2out.value = "", Length.value = "", RWidth.value = "", Answer.value = "", Stories.value = "", Month.value = "", Day.value = "", Year.value = "")
}



// Gautam the buttons are listed below using alerts with the text when clicked on

function Software() {
	const [modal, setModal] = useState(false);
	const [modalData, setModalData] = useState('');
	const onSendData = (data) => {
		setModal(true)
		setModalData(data)
	}

	const modalDataContent = {
		data1: `Please record the date on which the measurements were taken using the example format.
		This is important to ensure that the measurement did not last more than 24 hours to maintain accuracy.`,
		data2: `Please numerically record the amount of people in the room during the measurement. 
		This number must remain unchanged throughout the testing period to find the most accurate value.`,
		data3: `Please numerically input whether your classroom is one or two stories tall. 
		The calculator becomes inaccurate for any room over two stories tall due to complications caused by height.`,
		data4: `Please numerically record the time in which you took your initial measurement of carbon dioxide, using the example format. 
		The hour should be recorded on the left side of the colon and the minute should be recorded on the right side.`,
		data5: `Please numerically input the amount of carbon dioxide recorded in ppm at the time of your initial measurement.`,
		data6: `Please numerically input the length of the room in either feet or meters. 
		The unit of measurment can be changed to either feet (ft) or meters (m) using the drop down menu next to the input bar.
		If you are having difficulty measuring the length, you can measure the ceiling or floor tiles, 
		if your classroom has either, and then count them to find the length.`,
		data7: `Please numerically record the time in which you took your final measurement of carbon dioxide, using the example format. The hour should be recorded on the left side of the colon and the minute should be recorded on the right side.`,
		data8: `Please numerically input the amount of carbon dioxide recorded in ppm at the time of your final measurement.`,
		data9: `Please numerically input the width of the room in either feet or meters.
		The unit of measurment can be changed to either feet (ft) or meters (m) using the drop down menu next to the input bar.
		If you are having difficulty measuring the width, you can measure the ceiling or floor tiles, 
		if your classroom has either, and then count them to find the width.`,
		data10: `This is your calculated ventilation rate in air changes per hour. 
		If the calculated value reads NaN (Not a Number) then the time value is most likely incorrectly input.`
	};

	return (
		<Container>
			<h1 className="mainTitle text-center">City@UMD Software</h1>
			<p>
				Below is a collection of applications, software, and digital tools that
				City@UMD has made over the years.
			</p>
			
			<hr />
			
			<Card style={{ marginBottom: 10 }}>
					{modal ? <Modal modal={modal} onSelectedChange={setModal} modalData={modalData}/> : ''}
					<Row>
						<Col>
							<CardHeader style={{marginLeft: 10}} title="DIY Ventilation Rate for Educational Facilities"> </CardHeader>
						</Col>
						<Col>
							<div style={{marginTop: 15, textAlign: "right", marginRight: 10}}>
						</div>
						</Col>
					</Row>
					<Row>
						<Col xs={12} sm={{ size: 8}}>
							<Typography style={{textAlign: "Left", margin:10}}> This calculator serves as a tool for calculating the ventilation rate of an educational room. The yellow highlighted buttons above each listed input can be click to provide you with more information on what data is required. <strong>All values must be entered as numbers for the calculator to work! </strong></Typography>
						<div style={{margin:10}} className="text-center">
						<Row style={{marginLeft: 0}}>
						<Col sm={{size: 4}}>
							<CardContent style={{marginLeft: 10}}>
								<Button
									variant = "contained"
									onClick={() => onSendData(modalDataContent.data1)}
									style={{width: 195, marginBottom: 5, backgroundColor: "#FFFACD"}}>Date (MM/DD/YYYY)</Button>
								<Input id="Month" style={{marginBottom: 10, width: 50,}}></Input>&nbsp; / &nbsp;
								<Input id="Day" style={{marginBottom: 5, width: 50,}}></Input>&nbsp; / &nbsp;
								<Input id="Year" style={{marginBottom: 5, width: 50,}}></Input>
								<Button
									color=""
									variant = "contained"
									onClick={() => onSendData(modalDataContent.data2)}
									style={{width: 195, marginBottom: 5, backgroundColor: "#FFFACD"}}>Number of People</Button>
								<Input id="NumP" style={{marginBottom: 10, width: 195}}> </Input>

								<Button
									color=""
									variant = "contained"
									onClick={() => onSendData(modalDataContent.data3)}
									style={{width: 195, marginBottom: 5, backgroundColor: "#FFFACD"}}> Stories (1 or 2)</Button>
								<Input id="Stories" style={{marginBottom: 10, width: 195, textAlign: "center"}}></Input>

								</CardContent>
						</Col>
						<Col sm={{size: 4}}>
							<CardContent style={{}}>
								<Button
									color=""
									variant = "contained"
									onClick={() => onSendData(modalDataContent.data4)}
									style={{width: 195, marginBottom: 5, backgroundColor: "#FFFACD"}}>Time in (Hour : Minute)</Button>

								<Input id="TinH" style={{marginBottom: 10, width: 50, className: "center"}}></Input>&nbsp; : &nbsp;
								<Input id="TinM" style={{marginBottom: 5, width: 75}}></Input>

								<select id="Timein_unit" style={{width: 50, borderWidth:1}}>
									<option value="AM">AM</option>
									<option value="PM">PM</option>
								</select>

								<Button
									color=""
									variant = "contained"
									onClick={() => onSendData(modalDataContent.data5)}
									style={{width: 195, marginBottom: 5, backgroundColor: "#FFFACD"}}>CO<sub>2</sub>&nbsp;in (ppm)</Button>
								<Input id="CO2in" style={{marginBottom: 10, width: 195}}> </Input>

								<Button
									color=""
									variant = "contained"
									onClick={() => onSendData(modalDataContent.data6)}
									style={{width: 195, marginBottom: 5, backgroundColor: "#FFFACD"}}>Length (ft or m)</Button>
								<Input id="Length" style={{marginBottom: 10, width: 155}}> </Input>

								<select id="Length_unit" style={{width: 40}}>
									<option value="Feet">ft</option>
									<option value="Meter">m</option>
								</select>

							</CardContent>
						</Col>
						<Col sm={{size: 4}}>
							<CardContent style={{}}>
								<Button
									color = ""
									variant = "contained"
									onClick={() => onSendData(modalDataContent.data7)}
									style={{width: 195, marginBottom: 5, backgroundColor: "#FFFACD"}}>Time out (Hour : Minute)</Button>
								<Input id="ToutH" style={{marginBottom: 0, width: 50, textAlign: "center"}}></Input>&nbsp; : &nbsp;
								<Input id="ToutM" style={{marginBottom: 10, width: 75}}> </Input>

								<select id="Timeout_unit" style={{width: 50, borderWidth:1}}>
									<option value="AM">AM</option>
									<option value="PM">PM</option>
								</select>

								<Button
									color = ""
									variant = "contained"
									onClick={() => onSendData(modalDataContent.data8)}
									style={{width: 195, marginBottom: 5, backgroundColor: "#FFFACD"}}>CO<sub>2</sub>&nbsp;out (ppm)</Button>
								<Input id="CO2out" style={{marginBottom: 10, width: 195}}> </Input>

								<Button
									variant = "contained"
									onClick={() => onSendData(modalDataContent.data9)}
									style={{width: 195, marginBottom: 5, backgroundColor: "#FFFACD"}}>Width (ft or m)</Button>
								<Input id="RWidth" style={{marginBottom: 10, width: 155}}> </Input>

								<select id="Width_unit" style={{width: 40, borderWidth:1}}>
									<option value="Feet">ft</option>
									<option value="Meter">m</option>
								</select>

							</CardContent>
						</Col>
						</Row>
						</div>
					</Col>
					<Col sm={{ size: 4}}>
					<div style={{marginBottom: 10, marginTop: 10}} className="text-left">
						<Button
							onClick={() => onSendData(modalDataContent.data10)}
							style={{width: 190, textAlign: "center"}}>
							Ventilation Rate (ACH):
						</Button>


						<Input value="" id="Answer" style={{marginLeft: 10, width: 185, textAlign: "left"}}></Input>

					<div style={{marginBottom: 10, marginTop: 10, textAlign: "left"}}>
						<Button
							color="primary"
							variant="outlined"
							onClick={() => Ventilation_Rate()}
							style={{width:195, marginRight:15}}
						>
							Calculate Ventilation Rate
						</Button>

						<Button
							color = "primary"
							variant = "outlined"
							style={{width:175}}
							onClick={() => clear()}>
							Reset Calculator
						</Button>
					</div>

					</div>
						<Image src="images/MusicRooms/SOM2540.jpg" style={{}}> </Image>
					</Col>
				</Row>
			</Card>

			{data.map(({ id, ...props }, index) => (
				<ApplicationDetails key={id} index={index} {...props} />
			))}
		</Container>
	);
}
export default Software;
